import { toCamelCase, toSnakeCase } from './String';

export interface Dict<T> {
  [key: string]: T;
}

export function isList(obj: any): boolean {
  return Symbol.iterator in Object(obj);
}

export function toCamelCaseObject(obj: Record<string, any>): Record<string, any> {
  return Object.entries(obj).reduce((acc, [key, val]) => {
    const camelKey = toCamelCase(key);
    return {...acc, [camelKey]: val};
  }, {});
}

export function toSnakeCaseObject(obj: Record<string, any>): Record<string, any> {
  return Object.entries(obj).reduce((acc, [key, val]) => {
    const snakeKey = toSnakeCase(key);
    return {...acc, [snakeKey]: val};
  }, {});
}

export function removeKeyWithValue<T, V>(obj: T, val: V): T {
  let newObj = { ...obj };
  for (let key in newObj) {
    if (newObj[key] === val) {
      delete newObj[key];
    }
  }
  return newObj;
}
